module.exports = __webpack_public_path__ + "assets/f9fe17221d04ba89105e96f839956560.mp3";